// extracted by mini-css-extract-plugin
export default {"wrapper":"CourseStep_wrapper__KqN44"};